import moment from 'moment';

import { getBidTotals } from 'utils';

const clientInfo = (client) => {
  const info = [];
  const city = client.city ? client.city : "";
  const province = client.province ? client.province : "";
  const country = client.country ? client.country : "";

  info.push({ text: "To", style: "infoHeaderText" });
  info.push({ text: client.fullName ? client.fullName : "" });
  client.address && info.push({ text: client.address ? client.address : "" });
  client.city && info.push({ text: `${city} ${province} ${country}` });
  client.postalCode && info.push({ text: client.postalCode ? client.postalCode : "" });

  return info;
};

export const bidInfo = (bid, bidTasks, client) =>
({
  style: "bidInfo",
  layout: "noBorders",
  table: {
    widths:["auto", "auto", "*", "auto"],
    heights: 120,
    body: [[
            {
                style: "attentionColumn",
                stack: clientInfo(client)
            },

            {
                style: "bidNumberColumn",
                stack: [

                    { text: "Date of Issue", style: "infoHeaderText" },
                    { text: bid.date ? moment(bid.date).format("MM/DD/YYYY") : "" },
                    { text: "Expires On", style: "infoSubheaderText" },
                    { text: bid.dueDate ? moment(bid.dueDate).format("MM/DD/YYYY") : "No Expiry" }
                ]
            },
            { text: "" },
            {
                style: "bidTotalColumn",
                stack: [
                    { text: "Bid Number", style: "infoHeaderText" },
                    { text: bid.bidNumber },
                    { text: "Bid Total", style: "infoSubheaderText" },
                    { text: `$${getBidTotals(bidTasks).total.toFixed(2)}` }
                ]
            }
    ]]
  }
});



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/bidInfo.js